import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { Client, getSDKSource, applySdkMetadata, _INTERNAL_flushLogsBuffer, addAutoIpAddressToSession } from '@sentry/core';
import { eventFromException as _eventFromException, eventFromMessage as _eventFromMessage } from './eventbuilder.js';
import { WINDOW } from './helpers.js';

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

var DEFAULT_FLUSH_INTERVAL = 5000;

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /*#__PURE__*/function (_Client) {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  function BrowserClient(options) {
    var _opts$_metadata;
    var _this;
    _classCallCheck(this, BrowserClient);
    var opts = applyDefaultOptions(options);
    var sdkSource = WINDOW.SENTRY_SDK_SOURCE || getSDKSource();
    applySdkMetadata(opts, 'browser', ['browser'], sdkSource);

    // Only allow IP inferral by Relay if sendDefaultPii is true
    if ((_opts$_metadata = opts._metadata) !== null && _opts$_metadata !== void 0 && _opts$_metadata.sdk) {
      opts._metadata.sdk.settings = _objectSpread({
        infer_ip: opts.sendDefaultPii ? 'auto' : 'never'
      }, opts._metadata.sdk.settings);
    }
    _this = _callSuper(this, BrowserClient, [opts]);
    var _this$_options = _this._options,
      sendDefaultPii = _this$_options.sendDefaultPii,
      sendClientReports = _this$_options.sendClientReports,
      enableLogs = _this$_options.enableLogs;
    if (WINDOW.document && (sendClientReports || enableLogs)) {
      WINDOW.document.addEventListener('visibilitychange', function () {
        if (WINDOW.document.visibilityState === 'hidden') {
          if (sendClientReports) {
            _this._flushOutcomes();
          }
          if (enableLogs) {
            _INTERNAL_flushLogsBuffer(_this);
          }
        }
      });
    }
    if (enableLogs) {
      _this.on('flush', function () {
        _INTERNAL_flushLogsBuffer(_this);
      });
      _this.on('afterCaptureLog', function () {
        if (_this._logFlushIdleTimeout) {
          clearTimeout(_this._logFlushIdleTimeout);
        }
        _this._logFlushIdleTimeout = setTimeout(function () {
          _INTERNAL_flushLogsBuffer(_this);
        }, DEFAULT_FLUSH_INTERVAL);
      });
    }
    if (sendDefaultPii) {
      _this.on('beforeSendSession', addAutoIpAddressToSession);
    }
    return _this;
  }

  /**
   * @inheritDoc
   */
  _inherits(BrowserClient, _Client);
  return _createClass(BrowserClient, [{
    key: "eventFromException",
    value: function eventFromException(exception, hint) {
      return _eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "eventFromMessage",
    value: function eventFromMessage(message) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
      var hint = arguments.length > 2 ? arguments[2] : undefined;
      return _eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, currentScope, isolationScope) {
      event.platform = event.platform || 'javascript';
      return _superPropGet(BrowserClient, "_prepareEvent", this, 3)([event, hint, currentScope, isolationScope]);
    }
  }]);
}(Client);
/** Exported only for tests. */
function applyDefaultOptions(optionsArg) {
  var _WINDOW$SENTRY_RELEAS;
  return _objectSpread({
    release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    ? __SENTRY_RELEASE__ : (_WINDOW$SENTRY_RELEAS = WINDOW.SENTRY_RELEASE) === null || _WINDOW$SENTRY_RELEAS === void 0 ? void 0 : _WINDOW$SENTRY_RELEAS.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: true,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: true
  }, optionsArg);
}
export { BrowserClient, applyDefaultOptions };